export const environment = {
  production: true,
  apiUrl: 'https://dealeroutlet-api.leolux.nl',
  domainGroups: [
    [
      { domain: 'dealeroutlet.leolux.nl', language: { visibleLanguages: ['nl-NL'] }, country: 'NL' },
      { domain: 'dealeroutlet.leolux.be', language: { visibleLanguages: ['nl-BE'] }, country: 'BE' },
      { domain: 'dealeroutlet.leolux.de', language: { visibleLanguages: ['de-DE'] }, country: 'DE' },
    ]
  ],
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/environments/environment.ts